import { all, takeEvery, put, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { flow } from '../modules/flow';
import { types, actions } from '../modules/visitante';
import usuarioService from '../../commons/services/usuario';

export default function* recuperarSenhaSaga() {
	yield takeEvery(types.GUEST_USER_CREATE, criarContaAsync);
	yield takeEvery(types.GUEST_PASSWORD_RECOVER, recuperarSenhaAsync);
	yield takeEvery(types.GUEST_PASSWORD_RECOVER_FINISH, redefinirSenha);
}

function* recuperarSenhaAsync(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			const [data] = yield all([
				call(() => usuarioService.recuperarSenha(action.payload)),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(actions.updateStore({ email: data.deEmail }));
		}
	});
}

function* criarContaAsync(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			yield all([
				call(() => usuarioService.cadastro(action.payload)),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(actions.updateStore({ ...action.payload }));
		}
	});
}

function* redefinirSenha(action) {
	yield* flow({
		type: action.type,

		fnTry: function*() {
			const [data] = yield all([
				call(() =>
					usuarioService.redefinirSenha(
						action.payload.token,
						action.payload.body
					)
				),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(actions.updateStore({ email: data.deEmail }));
		}
	});
}
